import { Icon } from 'assets/index'
import { SetStateAction, useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import useAuth from 'hooks/useAuth'
import useFetch from 'hooks/useFetch'
import OtpInput from 'react-otp-input'

import { UserContext } from 'context/userContext'
import BorderButton from 'components/Buttons/BorderButton'
import {
  PopUpContent,
  ErrorMsg,
  Content,
  InputContainer,
  FeedbackIcon,
} from './style'

export const PopUpState = {
  INITIAL: 0,
  BLOCKED: 1,
  SUCCESS: 2,
  FAILED: 3,
}

interface ContentItem {
  title: string
  titleTxt: string[]
  icon: string
}

interface ContentMap {
  [key: number]: ContentItem
}

interface IProps {
  setShowPinConfirmation: (value: boolean) => void
  setKey?: React.Dispatch<SetStateAction<number>>
  handleSend: (pin: string | number) => Promise<number>
  content: ContentMap
  setContent?: any
  setEnd?: () => void
  confirmButton: string
}

const PinConfirmation = (props: IProps) => {
  const {
    setShowPinConfirmation,
    setKey,
    handleSend,
    content,
    setContent,
    setEnd,
    confirmButton,
  } = props
  const { setShowModal } = useContext(UserContext)
  const [erro, setErro] = useState<string>('')
  const [pin, setPin] = useState<string>('')
  const api = useFetch()
  const { setToken } = useAuth()
  const [popUpState, setPopUpState] = useState<number>(PopUpState.INITIAL)
  const [loadingConfirm, setLoadingConfirm] = useState(false)
  const navigate = useNavigate()

  const onCancel = (refreshInput: boolean) => {
    setShowPinConfirmation(false)
    setPopUpState(PopUpState.INITIAL)
    setErro('')
    // Incrementa o refreshKey para forçar re-renderização
    if (refreshInput && setKey) setKey((prev: number) => prev + 1)
  }

  const handleClick = async () => {
    setErro('')
    if (pin.length < 4) {
      setErro('Código inválido.')
      return
    }

    setLoadingConfirm(true)

    // *******************************************************
    // PRIMEIRO, FAZ A REQUISICAO PARA AUTENTICAR O CODIGO SMS
    // *******************************************************
    try {
      const resPin = await api.fetch(
        'post',
        { code: pin },
        '/gestor/verify-sms-code'
      )

      console.log('res, res', resPin)
      if (resPin.fail || !resPin) {
        setLoadingConfirm(false)
        if (resPin?.status === 423) {
          setTimeout(() => {
            navigate('/login')
            setShowPinConfirmation(false)
            setShowModal(false)
            setToken('')
          }, 3000)
          return setPopUpState(PopUpState.BLOCKED)
        }
        if (resPin?.status === 401 || resPin?.status === 400) {
          return setErro(resPin.errors.message)
        }
        setContent((last: any) => ({
          ...last,
          3: {
            title: 'Erro de solicitação',
            titleTxt: [resPin.errors.message],
            icon: 'x_circle.svg',
          },
        }))
        setTimeout(() => {
          setShowPinConfirmation(false)
        }, 4000)
        return setPopUpState(PopUpState.FAILED)
      }
      // *******************************************************

      // *******************************************************
      // SEGUNDO, FAZ A REQUISICAO PASSADA POR PROP
      // *******************************************************

      const res = await handleSend(pin)
      setLoadingConfirm(false)
      setPopUpState(res)
      return setTimeout(() => {
        res === PopUpState.INITIAL &&
          setKey &&
          setKey((prev: number) => prev + 1)
        setEnd && setEnd()
        setShowPinConfirmation(false)
      }, 4000)
      // *******************************************************
    } catch (err: any) {
      setErro(err.message)
    } finally {
      setLoadingConfirm(false)
    }
  }

  const resendPin = () => {
    api.fetch('get', null, `/gestor/send-sms-code`)
  }

  return (
    <Content>
      <PopUpContent popUpState={popUpState}>
        <div className="title-container">
          <h1 className="title">
            <img
              src={Icon('x_circle.svg')}
              alt="security"
              className="title-icon"
            />
            {content[popUpState]?.title}
          </h1>
          <h2 className="subtitle">
            {content[popUpState]?.titleTxt.map(
              (subtitle: string, index: number) => (
                <h2 key={index} className="subtitle">
                  {subtitle}
                </h2>
              )
            )}
          </h2>
        </div>
        {popUpState === PopUpState.INITIAL ? (
          <>
            <InputContainer onClick={() => setErro('')} hasError={!!erro}>
              <OtpInput
                value={pin}
                onChange={setPin}
                numInputs={4}
                containerStyle="otp-container"
                inputStyle="input-style"
                renderInput={(inputProps) => <input {...inputProps} />}
                inputType="tel" // Use "tel" instead of "number" to avoid spin buttons
              />
              <ErrorMsg showErrror={!!erro}>
                <img
                  src={Icon('x_circle.svg')}
                  alt="secutity"
                  className="msg-icon"
                />
                {erro}
              </ErrorMsg>

              <div className="send-pin-container">
                Não recebeu um código?
                <button
                  className="send-pin-btn"
                  type="button"
                  onClick={resendPin}
                >
                  <img
                    src={Icon('send.svg')}
                    alt="close modal"
                    className="resend-icon"
                  />
                  Reenviar código
                </button>
              </div>
            </InputContainer>

            <div className="button-container">
              <BorderButton
                onClick={() => onCancel(true)}
                data-testid={`cancel-btn`}
                icon={Icon('x.svg')}
              >
                <p>Cancelar</p>
              </BorderButton>
              <div>
                <BorderButton
                  onClick={handleClick}
                  loading={loadingConfirm}
                  data-testid={`delete-btn`}
                  disabled={loadingConfirm}
                  type="button"
                  icon={Icon('check.svg')}
                  medium
                >
                  <p>{confirmButton}</p>
                </BorderButton>
              </div>
            </div>
          </>
        ) : (
          <FeedbackIcon
            popUpState={popUpState}
            src={Icon(content[popUpState].icon)}
            alt="status-icon"
            className="status-icon-feed-back"
          />
        )}
      </PopUpContent>
    </Content>
  )
}

export default PinConfirmation
